import { render, staticRenderFns } from "./weightGainBetweenTwoDays.vue?vue&type=template&id=a4dbdc50&scoped=true&"
import script from "./weightGainBetweenTwoDays.vue?vue&type=script&lang=js&"
export * from "./weightGainBetweenTwoDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dbdc50",
  null
  
)

export default component.exports